import { render } from "./Procuradores.vue?vue&type=template&id=45eee0a9&scoped=true"
import script from "./Procuradores.vue?vue&type=script&lang=js"
export * from "./Procuradores.vue?vue&type=script&lang=js"

import "./Procuradores.vue?vue&type=style&index=0&id=45eee0a9&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45eee0a9"]])

export default __exports__